/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * An enumeration.
 * @export
 * @enum {string}
 */
export enum PuescEwMissionStatus {
    Healthy = 'healthy',
    Unhealthy = 'unhealthy',
    Unknown = 'unknown',
    NoTransport = 'no_transport'
}

export function PuescEwMissionStatusFromJSON(json: any): PuescEwMissionStatus {
    return PuescEwMissionStatusFromJSONTyped(json, false);
}

export function PuescEwMissionStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PuescEwMissionStatus {
    return json as PuescEwMissionStatus;
}

export function PuescEwMissionStatusToJSON(value?: PuescEwMissionStatus | null): any {
    return value as any;
}

